import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { ComponentSize } from '../../atoms';
import { Color } from './types';

export const StyledLabel = styled.label<{
  size: ComponentSize;
  disabled: boolean;
  color: Color;
  flexLabel: boolean;
}>`
  cursor: pointer;

  ${({ flexLabel }) =>
    flexLabel &&
    css`
      display: inline-flex;
      align-items: center;
    `};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'InputLabel', 'size'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'InputLabel', 'color'))};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `};
  ${css((props) =>
    ThemeUtilities.getComponentCSSOverrides(props, 'InputLabel')
  )};
`;

export const Marker = styled.span<{ color: Color }>`
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'InputLabel', 'color'))};
`;

export const TextEllipsis = styled.span`
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
`;
